import {API} from "./API";
import {Invoice} from "../models/Invoice";

export class InvoicesAPI extends API<Invoice> {

	constructor () {
		super("invoices");
	}

	getByCustomer (customerId: string) {

		let url = `/invoices/customer/${customerId}`;
		return API.axiosInstance.get(url);
	}
}
